import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

import { ICredentials, TwcI18nModule, TwcIconApi, TwcTopconOneCredentials } from '@topcon/twc-angular';

import { MagnetService } from '@mirage-projects/cw-commons';
import { initializeMocks } from '@mirage-projects/cw-mocks';
import { ObjectHelperService } from '@mirage-projects/cw-utils';

import { environment } from '@collageweb/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppSiteComponent } from './app-site.component';
import { FooterModule } from './components/footer/footer.module';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { customIconsSite } from './custom-icons-site';
import { cookieConsentConfig } from './services/cookie-consent/cookie-consent-configuration';
import { CustomLoader } from './services/translate/custom-loader';
import { SharedModule } from './shared.module';

@NgModule({
    declarations: [AppSiteComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        SidebarModule,
        FooterModule,
        NgcCookieConsentModule.forRoot(cookieConsentConfig),
        TwcI18nModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomLoader,
                deps: [HttpClient, MagnetService, Location, ObjectHelperService],
            },
        }),
    ],
    providers: [
        {
            provide: TwcTopconOneCredentials,
            useFactory: (): ICredentials => environment.configuration?.topconOne,
        },
    ],
    bootstrap: [AppSiteComponent],
})
export class AppSiteModule {
    constructor() {
        this.updateSiteIcons();

        if (isDevMode()) {
            initializeMocks();
        }
    }

    /**
     * Adds/overwrites default icons for the Site's ones
     */
    updateSiteIcons(): void {
        const iconKeys = Object.keys(customIconsSite);

        iconKeys.forEach((shape) => {
            TwcIconApi.icons[shape] = customIconsSite[shape];
        });
    }
}
